import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import { PassengerType } from "../../../types/LegExtras";
import * as styles from "./PassengerTicketOptionsList.module.css";
const passengerType = (type) => {
  if (type === PassengerType.ADULT)
    return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "(", /* @__PURE__ */ React.createElement(FormattedMessage, {
    id: `transitLeg.passengerType.${type.toLocaleLowerCase()}`
  }), ")");
};
const PassengerName = ({ passenger }) => {
  if (!passenger) {
    return /* @__PURE__ */ React.createElement(FormattedMessage, {
      id: "transitLeg.allTravellers"
    });
  }
  const { firstName, lastName, type } = passenger || {};
  return /* @__PURE__ */ React.createElement(React.Fragment, null, firstName, " ", lastName, " ", passengerType(type));
};
const SinglePassenger = ({ extra }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = extra.paidExtras) == null ? void 0 : _a.map((paidExtra) => /* @__PURE__ */ React.createElement(Paragraph, {
    typeStyle: "mini",
    color: "subdued",
    key: `${paidExtra}-leg-extra`
  }, paidExtra)));
};
const MultiPassenger = ({ extras }) => /* @__PURE__ */ React.createElement("div", {
  className: styles.passengersList
}, extras.map(({ passenger, paidExtras }) => /* @__PURE__ */ React.createElement(Fragment, {
  key: (passenger == null ? void 0 : passenger.id) || "all-passengers"
}, /* @__PURE__ */ React.createElement(Paragraph, {
  typeStyle: "mini",
  color: "subdued",
  className: styles.passengerName
}, /* @__PURE__ */ React.createElement(PassengerName, {
  passenger
})), /* @__PURE__ */ React.createElement("div", {
  className: styles.ticketOptions
}, paidExtras == null ? void 0 : paidExtras.map((extra) => /* @__PURE__ */ React.createElement(Paragraph, {
  typeStyle: "mini",
  color: "subdued",
  key: `${(passenger == null ? void 0 : passenger.id) || "all-passengers"}-${extra}`
}, extra))))));
const PassengerTicketOptionsList = ({ extras }) => {
  if (extras.length === 1) {
    return /* @__PURE__ */ React.createElement(SinglePassenger, {
      extra: extras[0]
    });
  }
  return /* @__PURE__ */ React.createElement(MultiPassenger, {
    extras
  });
};
var PassengerTicketOptionsList_default = PassengerTicketOptionsList;
export {
  PassengerTicketOptionsList_default as default
};
